import React from 'react'

const Advertisement = () => {
    return (
        <div>Advertisement</div>
    )
}

export default Advertisement